module.exports = __webpack_public_path__ + "static/newart3-1a17105277b8fa6845df6e813a45ccd1.jpg";